import React from 'react'

import { Box, Typography } from "@mui/material"


export default function mainProviderColumn() {

	return {
		name: 'mainProviderNames',
		label: 'Main Provider',
		options: {
			setCellProps: () => ({ sx: { maxWidth: 100 } }),
			customBodyRowRenderLite: value => <Box
				sx={{
					display: "flex",
					justifyContent: "center",
					alignItems: "center"
				}}>
				<Typography>
					{!!value?.length ? value?.join(", ") : "Any"}
				</Typography>
			</Box>,
		}
	}
}